import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { ConfigurationService } from '../../services/configuration.service';
import { DriftConfiguration } from 'src/app/models/configuration.interface';
import { SetPersonasRequest, WorkspacePersona } from '../models/personas';

@Injectable()
export class WorkspacePersonaService {
  private readonly workspaceUrl = '/workspace';
  private config!: DriftConfiguration;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly configurationService: ConfigurationService
  ) {
    //No unsub required
    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  private get apiUrl() {
    return `${this.config.driftApi}${this.workspaceUrl}`;
  }

  public setWorkspacePersonas(workspaceId: string, data: SetPersonasRequest): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/persona`;
    return this.httpClient.post<void>(path, data);
  }

  public getWorkspacePersonas(workspaceId: string): Observable<WorkspacePersona[]> {
    const path = `${this.apiUrl}/${workspaceId}/persona`;
    return this.httpClient.get<WorkspacePersona[]>(path);
  }
}
